import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  InstructionPartsTitle,
  InstructionExtraPartsHead,
  InstructionExtraPartsBody,
} from '~/src/components/molecules'
import { TExtraPartsItem } from '~/src/types/instruction'

interface IExtraPartsProps {
  extraParts: TExtraPartsItem[]
}

/**
 * ExtraParts
 *
 * @param __namedParameters IExtraPartsProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const ExtraParts: React.FC<IExtraPartsProps> = ({ extraParts }) => {
  const { t } = useTranslation()

  return (
    <>
      <InstructionPartsTitle title={'Extra Parts'} />

      <Box component="div" sx={{ flexGrow: 1 }}>
        <InstructionExtraPartsHead />
        {extraParts.length > 0 &&
          extraParts.map((item: TExtraPartsItem) => (
            <InstructionExtraPartsBody
              key={item.itemName}
              itemName={item.itemName}
              orderName={item.orderName}
              status={item.status}
            />
          ))}
      </Box>
    </>
  )
}
